import React, { forwardRef } from "react";
import { Input } from "@chakra-ui/react";

type InputTextProps = {
  name: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  fontSize?: string;
  height?: string;
  width?: string;
  paddingY?: string;
  onChange?: (value: string) => void;
  type?: "text" | "tel" | "email" | "password" | "date";
  dataTestId?: string;
};

export const InputText = forwardRef<HTMLInputElement, InputTextProps>((props, ref) => {
  const {
    name,
    value,
    placeholder,
    disabled,
    fontSize = "xl",
    height = "auto",
    paddingY = 4,
    width,
    type = "text",
    onChange,
  } = props;
  const dataTestId = props.dataTestId ?? name;

  return (
    <Input
      data-testid={dataTestId}
      ref={ref}
      type={type}
      borderColor="gray.500"
      name={name}
      value={value || ""}
      placeholder={placeholder}
      _disabled={{
        opacity: 1,
      }}
      backgroundColor={disabled ? "gray.50" : "white"}
      disabled={disabled}
      cursor={disabled ? "not-allowed" : "text"}
      isReadOnly={disabled}
      fontSize={fontSize}
      height={height}
      width={width}
      paddingY={paddingY}
      onChange={(e) => {
        if (onChange) {
          onChange(e.target.value);
        }
      }}
      _hover={{
        borderColor: disabled ? "gray.500" : "blue.500",
      }}
    />
  );
});
